module.exports = __webpack_public_path__ + "static/media/gif-round-01.12f7a166.gif";